import React from "react";
import "./offer.scss";
import offerImage from "../../assets/UMSImage/offers.png";

const Offer = () => {
  return (
    <section id="services-offer-wrapper">
      <div className="row">
        <div className="col-md-6 offer-services">
          {/* <p className="title"></p> */}
          <h2 className="heading">
            Services <span>We Offer </span>
          </h2>
          <ul>
            <li>Credentialing & Enrollment </li>
            <li>Charge Entry & Charge Audit </li>
            <li>Accounts Receivable (Follow Ups) </li>
            <li>Custom Reports </li>
            <li>Bank Reconciliation (Monthly Basis) </li>
            <li>Fee Schedule Analysis </li>
            <li>Advance Eligibility & Benefits </li>
            <li>Denial Fixation and Remittance Services </li>
            <li>Patient Services </li>
            <li>Internal Audit (Quarterly) </li>
            <li>Daily / Weekly / Monthly Charges & Payment Reports </li>
            <li>Secondary Submissions / Appeals </li>
            <li>Billing Audit </li>
          </ul>
        </div>
        <div className="col-md-6">
          <img src={offerImage} alt="" />
        </div>
      </div>
    </section>
  );
};

export default Offer;
